export const MY_PAGE_REQUEST = 'MY_PAGE_REQUEST';
export const MY_PAGE_SUCCESS = 'MY_PAGE_SUCCESS';
export const MY_PAGE_FAIL = 'MY_PAGE_FAIL';
export const MY_PAGE_RESET = 'MY_PAGE_RESET';

export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';

export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL';
export const USER_REGISTER_RESET = 'USER_REGISTER_RESET';

export const USER_FORGOT_PASSWORD_REQUEST = 'USER_FORGOT_PASSWORD_REQUEST';
export const USER_FORGOT_PASSWORD_SUCCESS = 'USER_FORGOT_PASSWORD_SUCCESS';
export const USER_FORGOT_PASSWORD_FAIL = 'USER_FORGOT_PASSWORD_FAIL';
export const USER_FORGOT_PASSWORD_RESET = 'USER_FORGOT_PASSWORD_RESET';

export const USER_RESET_PASSWORD_REQUEST = 'USER_FORGOT_PASSWORD_REQUEST';
export const USER_RESET_PASSWORD_SUCCESS = 'USER_FORGOT_PASSWORD_SUCCESS';
export const USER_RESET_PASSWORD_FAIL = 'USER_FORGOT_PASSWORD_FAIL';
export const USER_RESET_PASSWORD_RESET = 'USER_FORGOT_PASSWORD_RESET';

export const USER_UPDATE_PROFILE_REQUEST = 'USER_UPDATE_PROFILE_REQUEST';
export const USER_UPDATE_PROFILE_SUCCESS = 'USER_UPDATE_PROFILE_SUCCESS';
export const USER_UPDATE_PROFILE_FAIL = 'USER_UPDATE_PROFILE_FAIL';
export const USER_UPDATE_PROFILE_RESET = 'USER_UPDATE_PROFILE_RESET';

export const USER_DETAILS_REQUEST = 'USER_DETAILS_REQUEST';
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS';
export const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL';
export const USER_DETAILS_RESET = 'USER_DETAILS_RESET';

export const USER_CHILDREN_REQUEST = 'USER_CHILDREN_REQUEST';
export const USER_CHILDREN_SUCCESS = 'USER_CHILDREN_SUCCESS';
export const USER_CHILDREN_FAIL = 'USER_CHILDREN_FAIL';
export const USER_CHILDREN_RESET = 'USER_CHILDREN_RESET';

export const USER_SEARCH_REQUEST = 'USER_SEARCH_REQUEST';
export const USER_SEARCH_SUCCESS = 'USER_SEARCH_SUCCESS';
export const USER_SEARCH_FAIL = 'USER_SEARCH_FAIL';
export const USER_SEARCH_RESET = 'USER_SEARCH_RESET';

export const USER_IS_BUILDER_REQUEST = 'USER_IS_BUILDER_REQUEST';
export const USER_IS_BUILDER_SUCCESS = 'USER_IS_BUILDER_SUCCESS';
export const USER_IS_BUILDER_FAIL = 'USER_IS_BUILDER_FAIL';
export const USER_IS_BUILDER_RESET = 'USER_IS_BUILDER_RESET';

export const USER_BUILDERS_REQUEST = 'USER_BUILDERS_REQUEST';
export const USER_BUILDERS_SUCCESS = 'USER_BUILDERS_SUCCESS';
export const USER_BUILDERS_FAIL = 'USER_BUILDERS_FAIL';
export const USER_BUILDERS_RESET = 'USER_BUILDERS_RESET';

export const USER_CHANGE_PASSWORD_REQUEST = 'USER_CHANGE_PASSWORD_REQUEST';
export const USER_CHANGE_PASSWORD_SUCCESS = 'USER_CHANGE_PASSWORD_SUCCESS';
export const USER_CHANGE_PASSWORD_FAIL = 'USER_CHANGE_PASSWORD_FAIL';
export const USER_CHANGE_PASSWORD_RESET = 'USER_CHANGE_PASSWORD_RESET';

export const USER_CHECKPOINTS_REQUEST = 'USER_CHECKPOINTS_REQUEST';
export const USER_CHECKPOINTS_SUCCESS = 'USER_CHECKPOINTS_SUCCESS';
export const USER_CHECKPOINTS_FAIL = 'USER_CHECKPOINTS_FAIL';
export const USER_CHECKPOINTS_RESET = 'USER_CHECKPOINTS_RESET';

// Delete
export const USER_CHECKPOINT_DELETE_REQUEST = 'USER_CHECKPOINT_DELETE_REQUEST';
export const USER_CHECKPOINT_DELETE_SUCCESS = 'USER_CHECKPOINT_DELETE_SUCCESS';
export const USER_CHECKPOINT_DELETE_FAIL = 'USER_CHECKPOINT_DELETE_FAIL';

export const USER_CHECKPOINT_CONFIRM_REQUEST = 'USER_CHECKPOINT_CONFIRM_REQUEST';
export const USER_CHECKPOINT_CONFIRM_SUCCESS = 'USER_CHECKPOINT_CONFIRM_SUCCESS';
export const USER_CHECKPOINT_CONFIRM_FAIL = 'USER_CHECKPOINT_CONFIRM_FAIL';

export const USER_BY_ID_REQUEST = 'USER_BY_ID_REQUEST';
export const USER_BY_ID_SUCCESS = 'USER_BY_ID_SUCCESS';
export const USER_BY_ID_FAIL = 'USER_BY_ID_FAIL';
export const USER_BY_ID_RESET = 'USER_BY_ID_RESET';
